import { NgModule } from '@angular/core';
import { FullLayoutComponent } from './full-layout.component';
import { SimpleLayoutComponent } from './simple-layout.component';
import {TabsModule, BsDropdownModule} from 'ngx-bootstrap';
import {AppRoutingModule} from '../app.routing';
import {NAV_DROPDOWN_DIRECTIVES} from '../shared/nav-dropdown.directive';
import {BreadcrumbsComponent} from '../shared/breadcrumb.component';
import {SIDEBAR_TOGGLE_DIRECTIVES} from '../shared/sidebar.directive';
import {AsideToggleDirective} from '../shared/aside.directive';
import {BrowserModule} from '@angular/platform-browser';
import {AppHeaderComponent} from './header/header.component';
import {AppBodyComponent} from './body/body.component';
import {MenuComponent} from './menu/menu.component';
import {SmartResizeDirective} from '../shared/smart-resize.directive';
import {UserRepo} from '../DAL/usersRepo';
import {SelectModule} from 'ng2-select';
import {TranslationSharedModule} from '../translation/translationSharedModule';
import {UserHelper} from "../utils/UserHelper";
import {DirectivesModule} from '../shared/directives/directives.module';

@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    TranslationSharedModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    SelectModule,
    DirectivesModule
  ],
  declarations: [
    NAV_DROPDOWN_DIRECTIVES,
    BreadcrumbsComponent,
    SIDEBAR_TOGGLE_DIRECTIVES,
    AsideToggleDirective,
    SmartResizeDirective,
    FullLayoutComponent,
    SimpleLayoutComponent,
    AppHeaderComponent,
    AppBodyComponent,
    MenuComponent
  ],
  providers: [
    UserRepo,
    UserHelper
  ]
})
export class LayoutModule { }



// WEBPACK FOOTER //
// C:/xampp/htdocs/roche/roche/src/app/layouts/layoute.module.ts